/**
 * Hyperliquid Constants
 *
 * API URLs, EIP-712 domain, and default configuration.
 * Builder config is parameterized — each tenant provides their own address.
 */

import type { HLBuilderConfig } from "./types";

// ============================================================================
// API Endpoints
// ============================================================================

export const HL_MAINNET_API = "https://api.hyperliquid.xyz";
export const HL_TESTNET_API = "https://api.hyperliquid-testnet.xyz";

export const HL_MAINNET_WS = "wss://api.hyperliquid.xyz/ws";
export const HL_TESTNET_WS = "wss://api.hyperliquid-testnet.xyz/ws";

// ============================================================================
// EIP-712 Signing Domain
// ============================================================================

export const HL_EIP712_DOMAIN = {
  name: "HyperliquidSignTransaction",
  version: "1",
  chainId: 42161, // Arbitrum One
  verifyingContract:
    "0x0000000000000000000000000000000000000000" as `0x${string}`,
} as const;

// ============================================================================
// Default Builder Config
// ============================================================================

/**
 * Default builder config — should be overridden per tenant via TenantConfig.
 * Fee rate is in basis points (10 = 0.1%).
 */
export const DEFAULT_BUILDER: HLBuilderConfig = {
  address: "0x0000000000000000000000000000000000000000",
  feeRate: 10,
};

// ============================================================================
// Trading Defaults
// ============================================================================

export const HL_DEFAULT_SLIPPAGE = 0.03; // 3% — IOC orders need sufficient slippage to fill
export const HL_MAX_LEVERAGE = 50;
export const HL_MIN_ORDER_SIZE_USD = 10;

// ============================================================================
// WebSocket Config
// ============================================================================

export const HL_WS_MAX_RECONNECT_ATTEMPTS = 10;
export const HL_WS_INITIAL_RECONNECT_DELAY = 1000;
export const HL_WS_MAX_RECONNECT_DELAY = 30000;
export const HL_WS_PING_INTERVAL = 30000; // 30s — HL expects periodic pings
